import React from "react";
import { Card, Typography, Flex } from "antd";
import { InfoPanel } from "../components/InfoPanel";
import { useThemeRuntime } from "../theme/ThemeRuntimeProvider";
import styles from "./PageHeader.module.scss";

export function PageHeader({
  title,
  description,
  steps = [],
  extra = null,
  guideTitle,
}) {
  // Override por pagina (editor de estilos): si hay texto definido para la
  // pagina actual lo usamos; si no, el valor i18n que llega por props.
  const { resolvedOverrides } = useThemeRuntime();
  const titleOv = resolvedOverrides["text.pageTitle"];
  const descOv = resolvedOverrides["text.pageDescription"];
  const finalTitle =
    typeof titleOv === "string" && titleOv.trim() ? titleOv : title;
  const finalDescription =
    typeof descOv === "string" && descOv.trim() ? descOv : description;

  return (
    <Card
      className={styles.card}
      variant="outlined"
      styles={{ body: { padding: 20 } }}
    >
      <Flex justify="space-between" align="flex-start" gap={16} wrap="wrap">
        <div className={styles.main}>
          <Typography.Title level={2} className={styles.title}>
            {finalTitle}
          </Typography.Title>

          {finalDescription ? (
            <Typography.Paragraph className={styles.description}>
              {finalDescription}
            </Typography.Paragraph>
          ) : null}
        </div>

        {extra ? <div className={styles.extra}>{extra}</div> : null}
      </Flex>

      {Array.isArray(steps) && steps.length > 0 ? (
        <div className={styles.guide}>
          <InfoPanel items={steps} title={guideTitle} initiallyOpen={false} />
        </div>
      ) : null}
    </Card>
  );
}
